















































































































import { defineComponent, computed, PropType, ref } from "@vue/composition-api";
import AttachedDeviceModel from "@/models/AttachedDeviceModel";
import useShorePower from "@/store/modules/useShorePower";
import { alarm, sensor } from "@/store";
import useTimerSchedule from "../../../store/useTimerSchedule";

export default defineComponent({
    components: {
        SensorHeader: () =>
            import(/* webpackChunkName: "components" */ "./SensorHeader.vue"),
        EnrollDialog: () =>
            import(/* webpackChunkName: "settings" */ "../Dialogs/EnrollDialog.vue"),
        PairToggle: () =>
            import(/*webpackChunkName: "components"*/ "../PairToggle.vue"),
        TimerDialog: () =>
            import(/* webpackChunkName: "settings" */ "../Dialogs/TimerDialog.vue"),
        ConfirmDialog: () =>
            import(/* webpackChunkName: "settings" */ "../Dialogs/ConfirmDialog.vue"),
        ConsumptionDialog: () =>
            import(/* webpackChunkName: "settings" */ "../Dialogs/ConsumptionDialog.vue"),
    },
    props: {
        value: Object as PropType<AttachedDeviceModel>
    },
    setup(props, { emit }) {
        const { GetStatus, turnOn, turnOff } = useShorePower();
        const { get } = useTimerSchedule();

        const paired = computed<boolean>(() => {
            if (
                props.value &&
                props.value.attachedDeviceId &&
                props.value.attachedDeviceId !== ""
            ) {
                return true;
            } else {
                return false;
            }
        });

        const responsive = computed<boolean>(() => {
            if (props.value.attachedDeviceId != null) {
                if (props.value.age < 4) {
                    return true;
                } else {
                    return false;
                }
            }
        });

        let switchStatus = computed<boolean>(() => {
            if (responsive.value) {
                return alarm.smartPlugOn;
            } else {
                return false;
            }
        });

        const showEnroll = ref(false);

        const showSuccess = computed<boolean>(() => {
            return alarm.deviceAdded;
        });

        const showTimeout = computed<boolean>(() => {
            return alarm.deviceTimedOut;
        });

        const successOk = () => {
            alarm.SetNewDeviceAdded(false);
            sensor.GetData();
        };

        const timeoutOk = () => {
            alarm.SetNewDeviceTimedOut(false);
            sensor.GetData();
        };
        const showTimer = ref(false);
        const showConsumption = ref(false);

        const imgSrc = computed(() => {
            return require(`@/assets/img/smartplug.png`);
        });

        const onEnroll = () => {
            showEnroll.value = true;
        };

        const sensorSyncronising = computed(() => {
            return sensor.syncSensor;
        });

        const switchToogle = () => {
            if (props.value) {
                if (switchStatus.value == true) {
                    turnOff(props.value.attachedDeviceId);
                } else {
                    turnOn(props.value.attachedDeviceId);
                }
                props.value.alarm1 = !props.value.alarm1;
            }
        };
        
        get(props.value.attachedDeviceTypeId);
        //GetStatus();

        return {
            onEnroll,
            paired,
            showEnroll,
            showTimer,
            showConsumption,
            imgSrc,
            responsive,
            showSuccess,
            successOk,
            showTimeout,
            timeoutOk,
            switchStatus,
            sensorSyncronising,
            switchToogle
        };
    }
});
